module.exports = __webpack_public_path__ + "img/pen.6bbec0bd.svg";